module.exports = __webpack_public_path__ + "static/media/hot_zgxgs.7ab22932.png";